export interface ICheckTargetPartnerCountryMatchContactCountryArgs {
  partnerCountryCode: string
  contactCountryCode: string
}

export const checkTargetPartnerCountryMatchContactCountry = ({
  partnerCountryCode,
  contactCountryCode,
}: ICheckTargetPartnerCountryMatchContactCountryArgs) => {
  return partnerCountryCode === contactCountryCode
}
